import React,{useState,useEffect} from "react";
import { useParams } from "react-router-dom";
import { Header } from "../wrappers/Header";
import Footer from "../wrappers/Footer";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import duyuruBanner from "../assets/img/2.jpg"

const DuyurularSingle = ({duyurular}) => {
  const { name } = useParams();
  const decodedTitle = decodeURIComponent(name.replace(/-/g, " "));

  const announcement = duyurular.find(
    (item) => item.title === decodedTitle
  );


  return (
    <>
      <Header />
      <div className="container">
        <div className="col-12 position-relative">
          <img className="text-main-img" src={duyuruBanner} alt="Banner" />
          <div className="text-main-center text-center text-white">
            <h1>{decodedTitle}</h1>
          </div>
        </div>
        <div className="text-white mt-5 mb-5">
          <h2>{decodedTitle}</h2>
          {announcement && <p className="mt-3">{announcement.info}</p>}
        </div>
      </div>
      <Footer />{" "}
    </>
  );
};

DuyurularSingle.propTypes = {
  duyurular: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    duyurular: state.duyurularData.duyurular,
  };
};

export default connect(mapStateToProps)(DuyurularSingle);

